module.exports = __webpack_public_path__ + "bd894d268b8f0f1568c438fc10684970.jpg";